import { classNames } from '@/util/tailwindHelpers'
import { pluralize } from '@/util/stringHelpers'
import ListLoading from '@/components/Loading/List'
import { BulkAssetListConfig } from '../types'
import List from '@/components/AssetsList'
import styles from './styles.module.scss'

type RightColumnProps = {
  listConfig: BulkAssetListConfig
  className?: string
}

export default function ListColumn({
  className,
  listConfig: { titleSuffix, preListSlot, isLoading, items, ItemComponent }
}: RightColumnProps) {
  const itemsLength = items?.length

  return (
    <div
      className={classNames('flex-1 flex flex-col min-h-0 gap-3', className)}
    >
      <h2 className="h5">
        {itemsLength} {pluralize('Item', itemsLength)} {titleSuffix}
      </h2>
      {isLoading ? (
        <ListLoading message="Loading Items" className="flex-1" />
      ) : (
        <div className="flex-1 flex flex-col gap-3">
          {preListSlot}

          <div className="flex-1 relative">
            <div
              className={classNames(
                'absolute inset-0 pr-1 overflow-y-scroll pb-3',
                styles.transferItems
              )}
            >
              <List items={items} ItemComponent={ItemComponent} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
